<template>
	<page-common type="ask-topic" :has-comments="hasComments" :detail="detail" :auto-open-app="false">
		<div class="m-focus bg-d" :style="{height: focusImgH}">
			<div class="bg-c" :style="{backgroundImage: 'url(' + webp(detail.image) + ')'}"></div>
			<span class="praise-num">{{detail.false_zan_num | numberFormat}}</span>
			<h4 class="title f-toe1">{{detail.title}}</h4>
		</div>
		<div class="m-desc">
			<div class="text f-taj" v-html="detail.interpretation"></div>
			<a class="more-btn"></a>
		</div>
		<div class="m-related" v-if="showRelated">
			<h4 class="m-bt">
				<span class="u-tt">相关问题</span>
			</h4>
			<ul>
				<li v-for="(item, index) of related">
					<a :class="['f-cb', 'ask-link', 'status-' + item.status]">
						<div class="f-fl col-l bg-d" v-if="item.image">
							<div class="bg-c" :style="{backgroundImage: 'url(' + webp(item.image) + ')'}">
							</div>
						</div>
						<div class="f-toe2 col-m">{{item.title}}</div>
					</a>
					<div class="info-l f-toe1">
						<span v-if="item.status + '' === '3'">{{item.rep_user_name}}回复</span>&nbsp;
					</div>
					<div class="info-r">
						<span class="praise-num">{{item.like_num | numberFormat}}</span>
						<span class="comment-num">{{item.comment_num | numberFormat}}</span>
					</div>
				</li>
			</ul>
		</div>
		<comment-normal :comments="comments"></comment-normal>
	</page-common>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as device from 'constants/device'
import imgMixin from 'mixins/image'
import PageCommon from './page-common'
import CommentNormal from './comment-normal'
import 'styles/page-ask-topic.less'

export default {
	mixins: [imgMixin],
	components: {
		PageCommon,
		CommentNormal
	},
	computed: {
		...mapGetters({
			detail: 'ask:topic:detail',
			related: 'ask:topic:related',
			comments: 'ask:topic:comments',
			hasComments: 'ask:topic:hasComments'
		}),
		focusImgH() {
			return 130 * (device.width) / 320 + 'px';
		},
		showRelated() {
			return !Jt.array.isEmpty(this.related);
		}
	},
	created() {
		this.init(this.$route.params.id);
	},
	methods: {
		...mapActions({
			init: 'ask:topic:init'
		})
	}
}
</script>


// WEBPACK FOOTER //
// page-ask-topic.vue?7dbf5917